import { GET_CATEGORIES } from "constants/categories";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_CATEGORIES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
